module.exports = __webpack_public_path__ + "static/ogp-flow-88af3a95d8907657380b8fb3a247bb7e.png";